import styled from '@emotion/styled';
import type { FC } from 'react';
import { IconArrowLeft, IconArrowRight } from '../Icons';

interface Props {
  isDown: boolean;
  showClosedToLeft?: boolean;
}

export const AnimatedArrow: FC<Props> = ({ isDown, showClosedToLeft }) => (
  <Wrapper degree={isDown ? (showClosedToLeft ? -90 : 90) : 0}>
    {showClosedToLeft ? <IconArrowLeft fixedWidth /> : <IconArrowRight fixedWidth />}
  </Wrapper>
);

const Wrapper = styled.div<{ degree: number }>`
  width: 21px;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${({ degree }) => degree}deg);
`;
